/* eslint-disable consistent-return */
/* eslint-disable camelcase */
import React, { useMemo } from "react";
import { connect } from "react-redux";
import { getJobsMaximum } from "store/modules/users/selectors";
import { FaLock } from "react-icons/fa";
import { history } from "store";
import { useTranslation } from "react-i18next";
import { ROLE_ADMIN } from "configs/user/rolesConfig";
import useInterviewTemplatesStore from "store/useTemplateJobStore.ts";
import { getCardInfoLoading } from "store/modules/profile/selectors";
import Button, { ButtonProps } from "./Button.tsx";
import TooltipInfo from "../Tooltip/Info/index";


interface JobCreateButtonProps {
  iconRight?: React.ReactElement;
  onClick?: () => void;
  maximumJobs: number;
  onboarding: {
    agency_jobs_amount: number;
  };
  role: string;
  isCardInfoLoading: boolean,
}

const JobCreateButton = ({
  onClick,
  iconRight,
  maximumJobs,
  onboarding,
  isCardInfoLoading,
  text,
  role,
  color,
  ...props
}: JobCreateButtonProps & ButtonProps) => {
  const { t } = useTranslation();
  const { isJobCreationLoading } = useInterviewTemplatesStore();

  const isAdmin = role === ROLE_ADMIN;

  const isMaxJobsReached = useMemo(() => {
    if (!onboarding) return false;

    return maximumJobs <= (onboarding.agency_jobs_amount || 0);
  }, [maximumJobs, onboarding]);

  const handleRedirect = () => {
    history.push("/plans?utm_source=internal&utm_medium=user&utm_campaign=locked_interviews");
  };

  const handleClick = (e?: React.MouseEvent<Element, MouseEvent>) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (isJobCreationLoading) return;

    if (maximumJobs <= onboarding?.agency_jobs_amount) {
      if (!isAdmin) return;

      return handleRedirect();
    }

    if (onClick) {
      return onClick(e);
    }
  };

  const isLoading = useMemo(() => typeof onboarding?.agency_jobs_amount !== "number", [onboarding]);

  const tooltipMessage = useMemo(() => (maximumJobs === 1 ? t("plans.maxJob", { value: maximumJobs }) : t("plans.maximumJobs", { value: maximumJobs })), [maximumJobs, t]);

  const dropdownOptions = useMemo(() => {
    if (isMaxJobsReached) return undefined;

    return props?.dropdownOptions;
  }, [isMaxJobsReached, props]);

  return (
    <TooltipInfo
      disabled={!isMaxJobsReached}
      position="top"
      message={tooltipMessage}
    >
      <Button
        {...props}
        dropdownOptions={dropdownOptions}
        iconLeft={
          isMaxJobsReached ? (
            <i className="fas gold fa-lock n-icon__medium right">
              <FaLock />
            </i>
          ) : <></>
        }
        iconRight={iconRight}
        text={text}
        className={color === "primary" ? "text-sm font-medium text-white px-4 py-2 rounded-full flex items-center" : ""}
        onClick={handleClick}
        color={color}
        isLoading={isLoading}
      />
    </TooltipInfo>
  );
};

const mapStateToProps = (state:any) => ({
  maximumJobs: getJobsMaximum(state),
  onboarding: state.dashboard?.onboarding,
  role: state?.users?.currentUser?.role,
  isCardInfoLoading: getCardInfoLoading(state)
});

export default connect(mapStateToProps)(JobCreateButton);
